import React, { useState } from 'react';
import { Menu, Layout } from 'antd';
import {
    UserOutlined,
    DashboardOutlined,
    FolderOpenOutlined,
    DatabaseOutlined,
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import SubMenu from 'antd/lib/menu/SubMenu';
import { SideBarType } from '../shared/common/interfaces';
import { routeConfig } from '../shared/common/constant';
import companyLogo from '../assets/logo2.png';
const { Sider } = Layout;
const sideBarData: SideBarType[] = [
    {
        key: routeConfig.home.path,
        name: routeConfig.home.name,
        icon: <DashboardOutlined />,
        link: routeConfig.home.path,
    },
    {
        key: 2,
        name: 'Master Detail',
        icon: <FolderOpenOutlined />,
        subMenuData: [
            {
                key: routeConfig.consigneeList.path,
                name: routeConfig.consigneeList.name,
                icon: <UserOutlined />,
                link: routeConfig.consigneeList.path,
            },
            {
                key: routeConfig.deliveryTerm.path,
                name: routeConfig.deliveryTerm.name,
                icon: <DatabaseOutlined />,
                link: routeConfig.deliveryTerm.path,
            },
            {
                key: routeConfig.paymentTerm.path,
                name: routeConfig.paymentTerm.name,
                icon: <DatabaseOutlined />,
                link: routeConfig.paymentTerm.path,
            },
            {
                key: routeConfig.productList.path,
                name: routeConfig.productList.name,
                icon: <DatabaseOutlined />,
                link: routeConfig.productList.path,
            },
            {
                key: routeConfig.packingType.path,
                name: routeConfig.packingType.name,
                icon: <DatabaseOutlined />,
                link: routeConfig.packingType.path,
            },
            {
                key: routeConfig.shippingMode.path,
                name: routeConfig.shippingMode.name,
                icon: <DatabaseOutlined />,
                link: routeConfig.shippingMode.path,
            },
            {
                key: routeConfig.portList.path,
                name: routeConfig.portList.name,
                icon: <UserOutlined />,
                link: routeConfig.portList.path,
            },
            {
                key: routeConfig.countryList.path,
                name: routeConfig.countryList.name,
                icon: <UserOutlined />,
                link: routeConfig.countryList.path,
            },
        ]
    },
    {
        key: routeConfig.proformaList.path,
        name: routeConfig.proformaList.name,
        icon: <UserOutlined />,
        link: routeConfig.proformaList.path,
    },
    {
        key: routeConfig.purchaseOrderList.path,
        name: routeConfig.purchaseOrderList.name,
        icon: <UserOutlined />,
        link: routeConfig.purchaseOrderList.path,
    },
    {
        key: routeConfig.preShipmentList.path,
        name: routeConfig.preShipmentList.name,
        icon: <UserOutlined />,
        link: routeConfig.preShipmentList.path,
    },
    {
        key: routeConfig.allPackingList.path,
        name: routeConfig.allPackingList.name,
        icon: <UserOutlined />,
        link: routeConfig.allPackingList.path,
    },
    {
        key: routeConfig.commercialInvoiceList.path,
        name: routeConfig.commercialInvoiceList.name,
        icon: <UserOutlined />,
        link: routeConfig.commercialInvoiceList.path,
    },
    {
        key: routeConfig.allFinalPackingList.path,
        name: routeConfig.allFinalPackingList.name,
        icon: <UserOutlined />,
        link: routeConfig.allFinalPackingList.path,
    }
];

const SideBarComponent = ({ sidebarChanged }: any) => {

    const [collapsed, setCollapsed] = useState<boolean>(false);
    const location = useLocation();
    const createSingleMenuItem = (eachSideBarMenuData: SideBarType) => {
        return (
            <Menu.Item key={eachSideBarMenuData.link} icon={eachSideBarMenuData.icon} title={eachSideBarMenuData.name}>
                <Link to={eachSideBarMenuData.link}>{eachSideBarMenuData.name}</Link>
            </Menu.Item>
        )
    }
    const createSingleSubMenuItem = (eachSideBarSubMenuData: SideBarType) => {
        return (
            <SubMenu key={eachSideBarSubMenuData.key} icon={eachSideBarSubMenuData.icon} title={eachSideBarSubMenuData.name}>
                {
                    eachSideBarSubMenuData.subMenuData?.map((eachSideBarMenuData: SideBarType) => (
                        createSingleMenuItem(eachSideBarMenuData)
                    ))
                }
            </SubMenu>
        )
    }
    const createAllMenuItem = (eachSideBarData: SideBarType) => {
        return (
            eachSideBarData.subMenuData ? createSingleSubMenuItem(eachSideBarData) : createSingleMenuItem(eachSideBarData)
        )
    }

    const openSideBar = () => {
        sidebarChanged(!collapsed);
        setCollapsed(!collapsed);
    };

    return (
        <Sider collapsible collapsed={collapsed} onCollapse={openSideBar} style={{
            overflow: 'auto',
            position: 'fixed',
            top: 0,
            left: 0,
            height: 'calc(100% - 48px)'
        }}>
            {/* <div className="logo" /> */}
            <img src={companyLogo} height={40} width={90} style={{ margin: '16px 3px'}} />
            <Menu theme="dark" mode="inline" defaultSelectedKeys={[location.pathname]} selectedKeys={[location.pathname]}>
                {
                    sideBarData.map((eachSideBarData: SideBarType) => (
                        createAllMenuItem(eachSideBarData)
                    ))
                }
            </Menu>
        </Sider>
    );
}
export default SideBarComponent